import styled from "@emotion/styled";

export const Input = styled.input`
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.colors.border.primary};
  outline: none;
  box-sizing: border-box;
  transition: border-color 0.15s;
  height: 40px;
  background-color: ${({ theme }) => theme.colors.background.secondary};
  color: ${({ theme }) => theme.colors.text.primary};
  font-size: ${({ theme }) => theme.font["body-xs"].fontSize};
  font-weight: ${({ theme }) => theme.font["body-xs"].fontWeight};
  font-family: ${({ theme }) => theme.font["body-xs"].fontFamily};
  padding: 0 16px;
  &::placeholder {
    color: ${({ theme }) => theme.colors.text["text/40%"]};
  }
  &:hover,
  &:focus {
    border-color: ${({ theme }) => theme.colors.text["highlight/1"]};
  }
`;
